import { useEffect, useRef } from "react";

/**
 * Keeps data fresh across devices with lightweight polling.
 * - runs `load` on mount / when deps change
 * - re-runs every `intervalMs` while the tab is visible
 * - re-runs immediately when the tab/window regains focus
 */
export function useAutoSync(load, deps = [], intervalMs = 12000) {
  const saved = useRef(load);
  saved.current = load;

  useEffect(() => {
    let active = true;
    const run = () => {
      if (active && document.visibilityState === "visible") saved.current();
    };
    run(); // initial fetch
    const id = setInterval(run, intervalMs);
    const onFocus = () => run();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      active = false;
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
